module.exports = __webpack_public_path__ + "static/media/404.a646d276.png";